import React, { useEffect, useState } from "react";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import Style from "./OneProductDiscountContainer.module.scss";
import Select from "react-select";
import {
  AddDiscountAPI,
  getSupplierListApi,
  getSupplierProdctsAPI,
} from "../../../../Api/PanelAdminServices";
import OneProductDiscountListTabel from "../../../Tables/Discount/OneProductDiscountListTabel/OneProductDiscountListTabel";
import { Modal } from "react-bootstrap";
import Button from "../../../Button/Button";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
const OneProductDiscountContainer = () => {
  const [suppliersState, setSuppliersState] = useState(null);
  const [productsState, setProductState] = useState(null);
  const [showDeleteModalState, setShowmodalState] = useState(false);
  const [showEditModalState, setShowEditModalState] = useState(false);
  const [disableEdit, setDisableEdit] = useState(false);
  const [disableRemove, setDisableRemove] = useState(false);
  const [ProductInfo, setProductInfo] = useState(null);
  const [supplierSelect, setSupplierSelect] = useState(null);
  const [DiscountType, setDiscountType] = useState(null);
  const [DiscountValue, setDiscountValue] = useState(null);
  useEffect(() => {
    getAllSupplierData();
  }, []);
  const getAllSupplierData = async () => {
    getSupplierListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setSuppliersState(res.suppliers)
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };

  const SupplierChangeHandler = async (value) => {
    setSupplierSelect(value);
    const supplierProductData = await getSupplierProdctsAPI(value.value);
    setProductState(supplierProductData.products);
  };
  const DiscountTypeChangeHandler = (e) => {
    setDiscountType(e.target.value);
  };

  const HideModlaHandler = () => {
    setShowmodalState(false);
    setShowEditModalState(false);
  };

  const showModalHandler = (value, data) => {
    setProductInfo(data);
    if (value === 2) {
      setShowmodalState(true);
    }
    if (value === 1) {
      setShowEditModalState(true);
    }
  };

  const RemoveDiscountHandler = () => {
    setDisableRemove(true)
    let info = {
      product_id: ProductInfo.productId,
      id: ProductInfo.categoryId,
      supplier_id: supplierSelect.value,
      const: 0,
      precentage: 0,
    };
    AddDiscountAPI(info, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        SupplierChangeHandler(supplierSelect);
        setDisableRemove(false)
      } else {
        errorToast(succ.message);
        setDisableRemove(false)
      }
    });
  };

  const EditeDiscountValueHandler = () => {
    setDisableEdit(true);
    let info = {
      product_id: ProductInfo.productId,
      id: ProductInfo.categoryId,
      supplier_id: supplierSelect.value,
      const: DiscountType === "2" ? 0 : DiscountValue,
      precentage: DiscountType === "1" ? 0 : DiscountValue,
    };
    AddDiscountAPI(info, (succ) => {
      if (succ.status === 1) {
        succToast(succ.message);
        SupplierChangeHandler(supplierSelect);
        setDisableEdit(false);
      } else {
        errorToast(succ.message);
        setDisableEdit(false);
      }
    });
  };
  return (
    <section className={Style.componentHolder}>
      <TableFixedPage title={"لیست تخفیف روی یک کالا"} />
      <Modal show={showDeleteModalState} onHide={HideModlaHandler}>
        <Modal.Header>
          <Modal.Title
            style={{ fontSize: "1rem", width: "100%", direction: "rtl" }}
          >
            آیا از حذف تخفیف موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={HideModlaHandler}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={RemoveDiscountHandler}
              disabledprops={disableRemove}
            />
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        show={showEditModalState}
        onHide={HideModlaHandler}
        className={Style.modalEdit}
      >
        <Modal.Header>
          <Modal.Title
            style={{ fontSize: "1rem", width: "100%", direction: "rtl" }}
          >
            ویرایش تخفیف
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <section
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              width: "100%",
            }}
          >
            <select
              name=""
              id=""
              style={{
                height: "3rem",
                borderRadius: "5px",
                margin: "0.5rem 0",
                textAlign: "right",
                width: "98%",
              }}
              onChange={DiscountTypeChangeHandler}
            >
              <option value="0">نوع تخفیف انتخاب کنید</option>
              <option value="2">درصد</option>
              <option value="1">مقدار</option>
            </select>
            {DiscountType === "1" ? (
              <input
                style={{
                  width: "98%",
                  height: "3rem",
                  borderRadius: "5px",
                  margin: "0.5rem 0",
                  textAlign: "right",
                  border: "none",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.253)",
                }}
                placeholder={"مقدار تخفیف"}
                onChange={(e) => setDiscountValue(e.target.value)}
                value={DiscountValue}
              />
            ) : DiscountType === "2" ? (
              <input
                style={{
                  width: "98%",
                  height: "3rem",
                  borderRadius: "5px",
                  margin: "0.5rem 0",
                  textAlign: "right",
                  border: "none",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.253)",
                }}
                placeholder={"درصد تخفیف"}
                onChange={(e) => setDiscountValue(e.target.value)}
                value={DiscountValue}
              />
            ) : null}
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-around",
                margin: "1rem 0",
              }}
            >
              <Button
                ClassBtn={"rejectBtn"}
                Value={"لغو"}
                ClickHandler={HideModlaHandler}
              />
              <Button
                ClassBtn={"confirmBtn"}
                Value={"ثبت"}
                ClickHandler={EditeDiscountValueHandler}
                disabledprops={disableEdit}
              />
            </div>
          </section>
        </Modal.Body>
      </Modal>
      <div className={Style.SupplierHolderDivison}>
        <p>ابتدا تامین کننده مورد نظر خودرا انتخاب کنید:</p>
        <Select
          options={
            suppliersState &&
            suppliersState.map((item) => {
              return {
                value: item.id,
                label: `${item.name} ${
                  item.type === "supermarket" ? "(سوپرمارکت)" : "(رستوران)"
                }`,
              };
            })
          }
          className={Style.selectOptionsearch}
          placeholder={"تامین کننده"}
          onChange={SupplierChangeHandler}
        />
      </div>
      <OneProductDiscountListTabel
        openModal={showModalHandler}
        data={productsState}
      />
    </section>
  );
};

export default OneProductDiscountContainer;
